<template>
  <Transition name="fade">
    <div v-if="isEditor.isOpen" class="card mb-4">
      <div class="card-header pb-0">
        <span class="font-weight-bolder" style="font-size: 22px; margin-right: 8px">Template Editor </span>
        <span style="float: right">
          <argon-button v-if="this.$store.state.templateEditor.mode == 'viewTemplate'" @click="closeEditor()" id="changepwd" checked="true" color="secondary" variant="outline" class="mx-2" size="md">Back</argon-button>
          <argon-button v-if="isResetPass" @click="updatePassword()" color="success" size="md">Save Changes</argon-button></span
        >
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="p-0">
          <div class="px-4 m-0 row">
            <div class="card-header pb-0">
              <h6 class="d-inline">Template Details</h6>
              <span v-if="this.$store.state.templateEditor.mode == 'createTemplate'" style="float: right">
                <argon-button @click="closeEditor()" id="changepwd" checked="true" color="secondary" variant="outline" class="mx-2" size="md">Cancel</argon-button>
                <argon-button @click="createTemplatetemplate()" color="success" size="md">Create template</argon-button></span
              >
              <argon-switch v-if="this.$store.state.templateEditor.mode == 'viewTemplate'" @click="toggleResetPass()" id="resetPass" class="d-inline-block" name="Reset Password" style="margin-left: 12px"></argon-switch>
              <span v-if="this.$store.state.templateEditor.mode == 'viewTemplate'" style="position: relative; left: -8px" class="text-xs text-secondary">Reset Password Toggle</span>
              <hr />
            </div>
            <div v-if="this.$store.state.templateEditor.mode == 'viewTemplate' && !isResetPass" class="col-md-6">
              <label for="example-text-input" class="form-control-label">Template Name</label>
              <div class="px-1 font-weight-bold text-md">{{ this.$store.state.adminlist.rows[this.$store.state.templateEditor.requestedrow].full_name }}</div>
            </div>
            <div v-if="this.$store.state.templateEditor.mode == 'viewTemplate' && !isResetPass" class="col-md-6 p-2">
              <label for="example-text-input" class="form-control-label">Email address</label>
              <div class="px-1 font-weight-bold text-md">
                <div class="px-1 font-weight-bold text-md">{{ this.$store.state.adminlist.rows[this.$store.state.templateEditor.requestedrow].email }}</div>
              </div>
            </div>

            <div v-if="this.$store.state.templateEditor.mode == 'createTemplate'" class="col-md-6">
              <label for="example-text-input" class="form-control-label">Template Name</label>
              <argon-input type="text" id="newfullname" value="" placeholder="Enter new template name" />
            </div>
            <div class="col-md-6">
              <label for="event-selector" class="form-control-label">Attachment</label>
              <Multiselect
                v-model="value"
                mode="single"
                :close-on-select="false"
                :searchable="true"
                :options="[
                  { value: 'a', label: 'QR Code' },
                  { value: 'b', label: 'RSVP Card' },
                  { value: 'c', label: 'Photo Selfie' },
                  { value: 'd', label: 'Photo Selfie + Frame' },
                  { value: 'e', label: 'No Attachment' },
                ]"
              />
            </div>
            <div v-if="this.$store.state.templateEditor.mode == 'createTemplate'" class="col-md-12 pb-2">
              <label for="example-text-input" class="form-control-label">Message Content</label>
              <ckeditor :editor="editor" :config="editorConfig"></ckeditor>
            </div>
            <div v-if="this.$store.state.templateEditor.mode == 'createTemplate'" class="col-md-12 pb-2">
              <label for="example-text-input" class="form-control-label d-block">Tags <span class="text-xs text-secondary opacity-5"> *Use these to insert available variables</span></label>

              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Guest Name</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Guest Address</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Man Name</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Man Fullname</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Woman Name</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Woman Fullname</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Reception Date</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Reception Location Name</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Reception Location Full</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Reception Maps Link</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Reception Time Start</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Reception Time End</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Akad Date</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Akad Location Name</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Akad Location Full</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Akad Maps Link</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">AKad Time Start</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Akad Time End</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Guest Pax Amount</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">Web Invitation Link</argon-button>
              <argon-button v-if="this.$store.state.templateEditor.mode == 'createTemplate'" color="secondary" variant="outline" class="m-1" size="md">RSVP Link</argon-button>
            </div>
            <div v-if="isResetPass" class="col-md-6">
              <label for="example-text-input" class="form-control-label">New Password</label>
              <input class="form-control" id="newpass" type="password" value="" placeholder="Type this template's new password" />
            </div>
            <div v-if="isResetPass" class="col-md-6">
              <label for="example-text-input" class="form-control-label">New Password Confirmation</label>
              <argon-input type="password" id="newpassconfirm" value="" placeholder="Make sure both new passwords are the same" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
  import ArgonInput from "@/components/ArgonInput.vue";
  import $ from "jquery";
  import ArgonButton from "@/components/ArgonButton.vue";
  import Multiselect from "@vueform/multiselect";
  import ArgonSwitch from "@/components/ArgonSwitch.vue";
  import "@vueform/multiselect/themes/default.css";
  import axios from "axios";
  import CKEditor from "@ckeditor/ckeditor5-vue";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

  export default {
    name: "template-editor",
    props: {
      cardBg: String,
      selectedOption: {},
    },
    components: {
      ArgonInput,
      ArgonButton,
      ArgonSwitch,
      Multiselect,
      ckeditor: CKEditor.component,
    },
    data() {
      return {
        templatedata: {},
        selects: {},
        editor: ClassicEditor,
        editorConfig: {
          toolbar: ["bold", "italic", "|", "link"],
        },
        item: {
          id: 1,
          // both the commented out value and the
          // active value don't work
          // relatedItem: {
          //   value: 100,
          //   label: "test",
          // },
          relatedItem: 100,
        },
      };
    },
    computed: {
      isSuper() {
        return localStorage.getItem(sha256("isSuper").toString());
      },
      isEditor() {
        return this.$store.state.templateEditor;
      },
      gettemplateData() {
        return this.templatedata;
      },
      options() {
        return this.options;
      },
    },
    methods: {
      getRoute() {
        const routeArr = this.$route.path.split("/");
        return routeArr[1];
      },
      toggleResetPass() {
        console.log($("#changepwd").is("checked"));
        return (this.$store.state.templateEditor.resetPass = !this.$store.state.templateEditor.resetPass);
      },
      closeEditor() {
        this.$store.state.templateEditor.isOpen = false;
      },
      updatePassword() {
        if ($("#newpass").val() == $("#newpassconfirm").val()) {
          let JWTToken = localStorage.getItem("token");
          let cred = {
            password: $("#newpass").val(),
          };

          axios
            .patch("https://api.macra.co.id/mavent/admin/reset-password", cred, { headers: { Authorization: `Bearer ${JWTToken}` } })
            .then((res) => {
              alert(res.message);
            })
            .catch((error) => {
              alert(error);
            });
        } else {
          $("#newpass").prop("required", true);
          $("#newpassconfirm").prop("required", true);
          setTimeout(() => {
            $("#newpass").prop("required", false);
            $("#newpassconfirm").prop("required", false);
          }, 3000);
          return alert("Both passwords have to be the same");
        }

        event.preventDefault();
      },
      createTemplatetemplate() {
        if ($("#newaccpwd").val() == $("#newaccpwdconfirm").val()) {
          let JWTToken = localStorage.getItem("token");
          let cred = {
            full_name: $("#newfullname").val(),
            email: $("#newemail").val(),
            username: $("#newusername").val(),
            password: $("#newaccpwd").val(),
          };

          axios
            .post("https://api.macra.co.id/mavent/admin/add", cred, { headers: { Authorization: `Bearer ${JWTToken}` } })
            .then((res) => {
              alert(res.status);
            })
            .catch((error) => {
              alert(error);
            });
        } else {
          return alert("Both passwords have to be the same");
        }

        event.preventDefault();
      },

      encrypt(ele) {
        return sha256(ele);
      },
      getAdminData(row) {
        return (this.templatedata = this.$store.state.adminlist.rows[row]);
      },
      async fetchOptions(search) {
        console.log(search);
        // hits an API
        // /api/items/search?search=${search}
        return new Promise((resolve) => {
          setTimeout(() => {
            if (search) {
              resolve([
                {
                  value: 100,
                  label: "test",
                },
                {
                  value: 101,
                  label: "test2",
                },
              ]);
            } else {
              resolve([]);
            }
          }, 200);
        });
      },
    },
    mounted() {
      if (this.$store.state.templateEditor.requestedrow != null) {
        this.getAdminData(this.$store.state.templateEditor.requestedrow);
      }
    },
  };
</script>
